export default __webpack_public_path__ + "static/media/canloc.adafe5d5.png";